import { toTitle } from './formatString'

// 'wordpress/corporate/business' -> Wordpress / Corporate / Business
export const formatClassfication = (classification: string | undefined) => {
  return classification
    ? classification
        .split('/')
        .map(category => toTitle(category))
        .join(' / ')
    : ''
}
